var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('loading',{staticClass:"loader",attrs:{"height":25,"color":"#1ba5a4","opacity":1,"width":25,"active":_vm.is_loading,"is-full-page":false,"can-cancel":false,"background-color":"#ffffff"},on:{"update:active":function($event){_vm.is_loading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }